<div class="border-2 h5 p text-bg-warning d-flex justify-content-between px-4 py-2 mb-0">
  Currently Active Documents Opened By Others
  <div class="h6" triggers="hover" ngbPopover="These are the currently opened documents in other browsers. You can take them over to
  allow yourself to save changes and continue editing that case afterwards.">
    What is this?
    <i class="bi-question-circle-fill text-ellipsis h6"></i>
  </div>
</div>

<div class="pt-0 h-100 d-block flex-grow-1 overflow-y-scroll">
  <div *ngIf="loading" class="text-center h-100 d-flex">
    <div class="loader-container d-flex flex-column h-100 w-100 justify-content-center loader-container">
      <!-- <div class="background"></div> -->
      <div class="loader-container translucent-div">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden"></span>
        </div>
        <div>Loading Document Sessions...</div>
      </div>
    </div>
  </div>
  <header class="grid gap-1 position-sticky top-0 px-4">
    <div class="g-col-4"><strong>Document Name</strong></div>
    <div class="g-col-1 text-center"><strong>Browser</strong></div>
    <div class="g-col-1 text-center"><strong>Opened By</strong></div>
    <div class="g-col-2"><strong>Last Active Time</strong></div>
    <div class="g-col-4"><strong>Actions</strong></div>
  </header>
  <div class="tx-table h-100 d-block">
    <!-- Original Header -->
    <div *ngIf="groupedSessions.length === 0 && !loading" class="text-center p-3">
      <p>No documents found.</p>
    </div>
    <div *ngIf="groupedSessions.length != 0 && !loading" class="d-block h-100">
      <!-- Grouped Sessions -->
      <div *ngFor="let group of groupedSessions">
        <!-- Contact Group Header -->
        <div class="group-header-contact px-4 position-sticky">
          <strong>Contact:</strong>
          {{ group.lastName != null ? group.firstName + ' ' + group.lastName : 'No contact' }}
        </div>
        <div *ngFor="let case of group.cases">
          <!-- Case Group Header -->
          <div class="group-header-case pb-0 px-4 position-sticky">
            <strong>Case:</strong>
            {{ case.sessions[0].contactCaseDetails.description }}
          </div>
          <div *ngFor="let s of case.sessions" class="grid tx-table-row gap-1 px-4" (click)="onSessionSelected(s)">
            <div class="g-col-4 ps-1 d-flex align-items-center gap-3">
              <i [class]="'bi bi-' + getIconExtension(s.contactCaseDetails.filename)"></i>
              <div class="text-truncate" triggers="hover" [ngbPopover]="getDocumentNameTooltip(s)">
                {{ getDocumentName(s) }}
                <!-- Show dirty flag if document has an autosave -->
                <span *ngIf="isDirty(s.session)">*</span>
              </div>
            </div>
            <div class="g-col-1 text-center">{{ getUserAgentName(s.session.userAgent) }}</div>
            <div class="g-col-1 text-center">{{ s.session.initials }}</div>
            <div class="g-col-2">
              {{
                (s.session.dateAutosaved != null ? s.session.dateAutosaved : s.session.dateCreated)
                  | date : 'MM/dd/yyyy, h:mm a'
              }}
            </div>
            <div class="g-col-4">
              <div class="d-flex align-items-stretch gap-2 h-100 justify-content-around pe-3">
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm sbtn py-3"
                  triggers="click"
                  placement="left"
                  *ngIf="s.session.txTextControlSessionId"
                  (shown)="getSessionThumbnail(s.session)"
                  (hidden)="clearSessionThumbnail()"
                  [ngbPopover]="popImagePreviewContent">
                  View
                </button>
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm sbtn flex-grow-1 py-3"
                  (click)="onTakeoverClicked(s.session, s)"
                  triggers="hover"
                  [openDelay]="300"
                  ngbPopover="Opens the document in the current state in this browser and closes it in the other broswer.">
                  Take over
                </button>
                <!-- Don't display button for pdfs until we find a way to save -->
                <button
                  *ngIf="isDirty(s.session) && !isPdf(s.contactCaseDetails.filename)"
                  type="button"
                  class="btn btn-outline-danger btn-sm sbtn flex-grow-1 py-3"
                  (click)="onSaveClicked(s.session)"
                  triggers="hover"
                  [openDelay]="300"
                  ngbPopover="Saves changes and closes the document.">
                  Save & Close
                </button>
                <button
                  type="button"
                  class="btn btn-outline-danger btn-sm sbtn flex-grow-1 py-3"
                  (click)="onCloseClicked(s.session)"
                  triggers="hover"
                  [openDelay]="300"
                  ngbPopover="Discards changes and closes the document.">
                  Discard & Close
                </button>
              </div>
            </div>
          </div>
        </div>

        <form
          ngNoForm
          [action]="submitUrl"
          method="post"
          enctype="application/x-www-form-urlencoded"
          target="_blank"
          #openInNewTabForm>
          <input type="hidden" id="filename" name="filename" />
          <input type="hidden" [id]="sessionId" [name]="sessionId" />
          <input type="hidden" id="activeSessionId" name="activeSessionId" />
          <input type="hidden" id="activeSessionAnswerPoolId" name="activeSessionAnswerPoolId" />
        </form>
      </div>
    </div>
  </div>
</div>
<ng-template #popImagePreviewContent>
  <div *ngIf="loadingPreview" class="text-center d-flex" style="height: 40%">
    <div class="loader-container d-flex flex-column h-100 w-100 justify-content-center loader-container">
      <!-- <div class="background"></div> -->
      <div class="loader-container translucent-div">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden"></span>
        </div>
        <div>Loading preview...</div>
      </div>
    </div>
  </div>
  <div *ngIf="!loadingPreview && previewImage" class="text-center d-flex" style="width: 400px">
    <img [src]="previewImage" width="400px" />
  </div>
</ng-template>
